var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "url(#pattern0_1_3508)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1_3508",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_3508",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_3508",
    width: 24,
    height: 24,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYEAYAAACw5+G7AAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAAGYktHRAAAAAAAAPlDu38AAAAJcEhZcwAAAGAAAABgAPBrQs8AAAAHdElNRQfnBgsLLhiL6o2gAAAET0lEQVRYw82WbUxTdxTGn/9tlWSRiQOBzIBjzUKjbrgIw8EMTkaGUqBltDBcyCasmVMYmjKdvDpsAVkgIgvCfEUdgVJKmTMuISoyAglkOAwjSPcF2EKVZQTcByj3nn0qyyBN242359v9v5zz/M49N+cyrFEVUHWUQuPtbbXyP5FZLoeG1MQnJOAqvqSvQkJYFK6j7uJFttpGT3x+zkPW6+8v6uRKuUsKBXpRx3YkJGAMm1AfHo4KvAtPkWjRxWvYg2eTkysGkOt/Pj32fECA4IcQ9ktcHMrAs0ilEkGowFRYGLTIhIk57YddpXhk3Lmz5AB566oGYtO3b+drUMsFy2SQUiC8YmNxCzyuh4cvVR4KQiZFqtX/GcBmdG6WtnHfKJXsBm6iKykJg/gTpVLpUhdmXs8QSJcEwfo7Vzt3d8sWuwAFVEAFxHFzbd7K/k1hYXSZzxcEmQwD7C+8kJgIGXoRJJEsm1F72omjdLC9XafKYK2qvXvFSmVjo1IpEknKnzbOjEZFibYKl1llQoK1BKa+Trkc00IEi9i8GQGsHQAQsLyVxQYMsTSOs3vuHGpxz2i0PYpf6bJkz/rp9aiGhs0qFHQS16AFMA0s6xfOsB8SiwUN+IheN5mggoqlqdV2z+egEvFE/JzwVHjNaEQngGqAwzCyMBEaupxe/yU1dpCxpUV0ls0IU5GR9BBz7KRc7vBePC5Qck9P6dnPJm8Fj4zYljlqo/eQmpxMeRjGj/fv4xh+wB88v2SGDfDEwakpmkAofj10SPdSxtutnELBvwkZ931xMdMhBcHe3g7jpLBWVtfcvHB5UZd8sa8qRD7o6cli6LEgiYnBMUSgWanEx6hiv0VHwwcmPBCLHSZ8Hz9TRVeX4MFNIiU1tcTvSFNrt9l8arbKUy5Xq1FIhUQ1Nc7WgdvDD1C2VHpmf9aF1reGhuwC2JNDsDxUUgwRbUUZC9TpzCof/XpVUZFer1Lp9Tyfm1QZLddIJEIq95BG+vrQSTmYcXd37Jw+QVx/v+5M5jpTWlCQwzfgqrITv0480Ojr65Zm9RK/uHHjwgoVUAFFkFhsfcNr0uNBRweicAPlu3c7G5+0OIqW06eLWQYzscLChfuOW8GBypqONN1WjY+jCQDGxxfuz8ILHsjNZS4anzcohQU3DQZ7+5wrwVyRbVKzdIyiPCfH5QD7cBuvms1FQxm+pg8ePVpxAP7wnBnaiQmU4FMYnf9Js4lpcQXSpiZH55YNQFeZFf+dj8VCG/AyBjs6XI9A7mz6n4m74gDzCXZhFFf0eqcvHIeU6sbGtPcynms53NOz6gD0Dv+hEGowOD0g76KfPW8wAIwBRKsO4GorsWDmQ5rFE3fVAOYTOWglOoVv0fvkyeMT3uvdRjo71xyAo1ZiOyGmkpYW2+RecwAOW+k4qpnR+dax6X9PYpfVRho05OdjnO2Ctb4eDYikbd3dwwd8fNw0bW2uhvsbbnvZ/xGNrh0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMove);
export default __webpack_public_path__ + "static/media/arrow_move.49a70321df5d5a1680cf3d53014c8d81.svg";
export { ForwardRef as ReactComponent };